<script>
    import {Doughnut, mixins} from 'vue-chartjs';

    const {reactiveProp} = mixins;

    export default {
        extends: Doughnut,
        mixins: [reactiveProp],
        props: ['options'],
        data: () => ({
            defaultOptions: {
                responsive: true, maintainAspectRatio: false
            }
        }),
        mounted() {
            this.renderChart(this.chartData, {...this.defaultOptions, ...this.options})
        }
    }
</script>